import React from "react";
import ScrollableTable from "../../../../Universal/Tables/ScrollableTable.component";
import "../../../../../styles/Pages/Setting/Profile/PositioSetup/PositioSetup.style.css";
const SalarySlabInfo = ({ _data, onEdit }) => {
  return (
    <div className="salarySlabInfoContainer w-full flex-col align-left justify-start g-2">
      <div
        className="w-full flex-row align-left justify-start g-3 overflow-hide"
        style={{ height: "26rem" }}
      >
        <div
          className="flex-col align-left justify-start g-2"
          style={{ width: "35%" }}
        >
          <h3 className="color-textGray poppins-medium t-18 weight-500">
            Slab {_data?.slabNo}
          </h3>
          <div className="flex-col align-left justify-start g-1">
            <div className="flex-col align-left justify-start g-05">
              <span className="t-14 poppins color-textGray">Grade</span>
              <span className="t-14 poppins color-textColor">
                {_data?.grade}
              </span>
            </div>
            <div className="flex-col align-left justify-start g-05">
              <span className="t-14 poppins color-textGray">
                Yearly CTC (INR)
              </span>
              <span className="t-14 poppins color-textColor">
                ₹ {_data?.yearlyCtc}
              </span>
            </div>
            <div className="flex-col align-left justify-start g-05">
              <span className="t-14 poppins color-textGray">
                Monthly calculative
              </span>
              <span className="t-14 poppins color-textColor">
                ₹ {_data?.monthlySalary}
              </span>
            </div>
            <div className="flex-col align-left justify-start g-05">
              <span className="t-14 poppins color-textGray">Positions</span>
              <ol className="ml-1">
                {_data?.position?.map((pos) => (
                  <li className="t-14 poppins color-textColor">{pos}</li>
                ))}
              </ol>
            </div>
          </div>
        </div>

        <div className="flex-1 h-full flex-col align-end justify-between">
          <ScrollableTable
            className="salarySlabInfoTable"
            thead={["Cause of deduction", "Deduction amount (INR)"]}
          >
            {_data?.deducation?.map((deducation) => {
              return (
                <tr>
                  <td>{deducation?.cause}</td>
                  <td>₹ {deducation?.amount}</td>
                </tr>
              );
            })}
          </ScrollableTable>
          <div className="flex-row align-center justify-start g-1">
            <h3 className="weight-500 t-18 poppins-semiBold color-textGray">
              Gross salary:
            </h3>
            <span className="t-18 color-textColor poppins">
              ₹ {_data?.grossSalary}
            </span>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="actionBtn w-full"
        onClick={() => onEdit(_data)}
      >
        Edit
      </button>
    </div>
  );
};

export default SalarySlabInfo;
